import styled from 'styled-components';

export const Heading2 = styled.h2`
  font-family: 'Rubik';
  font-size: ${(p) => p.fontSize ? p.fontSize : '2.2rem'};
  line-height: ${(p) => p.lineHight ? p.lineHight : '28px'};
  color: ${(p) => p.textColor ? p.textColor : p.theme.colors.black.base};
  margin: ${(p) => p.margin ? p.margin : ''};
  font-weight: 600;
  text-shadow: 1px 1px 2px #00000040;
`;